import axios from "axios";
import { TOKEN_KEY, HTTP_UNAUTHORIZED, HTTP_FORBIDDEN } from "@/data/constData";
import { PATH_LOGIN } from "@/data/pathData";
import store from "@/store";
import { refreshToken } from "@/api/auth";
import router from '@/router';

//  const BASE_URL = "https://aspire.teosite.com/api";
const BASE_URL = "https://dev.designbyaspire.com/api";
//const BASE_URL = "http://localhost:5000/api";
//const BASE_URL = "http://localhost:9000/api";

let http = axios.create({
	baseURL: BASE_URL,
	withCredentials: true,
	headers: {
		Accept: "application/json",
		"Content-Type": "application/json",
		//Authorization: localStorage.getItem(TOKEN_KEY) || null,
		//Authorization: store.getters.accessToken,
	},
});


// Request Inceptor
http.interceptors.request.use(function (config) {
	const accessToken = store.getters.accessToken
	if (accessToken != null) {
		config.headers.authorization =`Bearer ${accessToken}` ;
	}
	return config;
}, function (err) {
	return Promise.reject(err);
});


let isRefreshing = false;
let refreshSubscribers = [];



http.interceptors.response.use(response => {
	return response;
  }, error => {
	const { config, response: { status } } = error;
	const originalRequest = config;
//if (status === 400) {

	//	store.dispatch("logout");
    //    router.push(PATH_LOGIN);

	//}

	if (status === 403) {
	//   if (!isRefreshing) {
	// 	isRefreshing = true;

	// 	http.post('/user/refreshToken',{},{withCredentials: true}
	// 	).then((respaonse) => {
	// 	  const { data } = respaonse;
	// 	  isRefreshing = false;
	// 	  onRrefreshed(data.accessToken);
	// 	 // localStorage.setItem(TOKEN_KEY, data.accessToken);
	// 	  store.dispatch('setToken',data.accessToken);
	// 	  http.defaults.headers['Authorization'] = 'Bearer ' + data.accessToken;
	// 	  subscribers = [];
	// 	}).catch(err =>{

	// 	});
	//   }

	//   const retryOrigReq = new Promise((resolve, reject) => {
	// 	subscribeTokenRefresh(token => {
	// 	  // replace the expired token and retry
	// 	  originalRequest.headers['Authorization'] = 'Bearer ' + token;
	// 	  resolve(http(originalRequest));
	// 	})
	//   });
	//   return retryOrigReq;
	}
	 else {
	  return Promise.reject(error);
	}


  });

  function subscribeTokenRefresh(cb) {
	refreshSubscribers.push(cb);
  }

  function onRrefreshed(token) {
	refreshSubscribers.map(cb => cb(token));
  }





export default http;
